import KickImage from 'Reuseables/KickImage';
import { Row } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';

import Text from 'Pages/Home/Components/Atoms/Text';
import ProfilePic from 'images/no-profile.png';
import Styles from './ButtonProfile.module.scss';
import { TButtonProfile } from './definitions';

const ButtonProfile: React.FC<TButtonProfile> = ({ dataAuth }) => {
  const history = useHistory();
  const { img_url } = dataAuth?.userdata;

  const onClickProfile = () => {
    if (
      dataAuth?.isLogged &&
      dataAuth?.userdata.roles.length > 0 &&
      dataAuth?.userdata.email
    ) {
      if (window.innerWidth > 1095) {
        history?.push('/user_dashboard/profile-settings');
      } else {
        history?.push('/user_dashboard');
      }
    } else {
      history?.push('/login');
    }
  };

  return (
    <Row
      align="middle"
      gutter={12}
      className={Styles['profile-container']}
      onClick={onClickProfile}
    >
      <KickImage
        src={img_url ? img_url : ProfilePic}
        className={Styles['profile-image']}
      />
      <Text className={Styles['profile-email']}>
        {dataAuth?.userdata?.email}
      </Text>
    </Row>
  );
};

export default ButtonProfile;
